/* eslint-disable react-hooks/exhaustive-deps */
import { Container, Grid } from '@material-ui/core';
import { Box, LinearProgress } from '@mui/material';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useHistory } from 'react-router-dom';
import Swal from 'sweetalert2';
import { globalColors } from '../../../../../../_metronic/_assets/sass/custom/globalColors';
import { ReactComponent as IconCircleRight } from '../../../../../assets/icons/icon_circle-chevron-right-fill.svg';
import InputForm from '../../../../../components/InputForm';
import { AppAPIService } from '../../../../../services/AppAPIService';
import { FormatMoney } from '../../../../../utils/FormatMoney';
import Loading from '../../../../home/components/Loading';
import FormActions from '../../../components/FormActions';
import { Button } from './styles';
import styles from './styles.module.scss';
import { ConfirmModal } from '../components/ConfirmModal';

const stateOptions = [
  { value: 'TODOS', label: 'Todos os estados' },
  { value: 'AC', label: 'AC - Acre' },
  { value: 'AL', label: 'AL - Alagoas' },
  { value: 'AP', label: 'AP - Amapá' },
  { value: 'AM', label: 'AM - Amazonas' },
  { value: 'BA', label: 'BA - Bahia' },
  { value: 'CE', label: 'CE - Ceará' },
  { value: 'DF', label: 'DF - Distrito Federal' },
  { value: 'ES', label: 'ES - Espírito Santo' },
  { value: 'GO', label: 'GO - Goiás' },
  { value: 'MA', label: 'MA - Maranhão' },
  { value: 'MT', label: 'MT - Mato Grosso' },
  { value: 'MS', label: 'MS - Mato Grosso do Sul' },
  { value: 'MG', label: 'MG - Minas Gerais' },
  { value: 'PA', label: 'PA - Pará' },
  { value: 'PB', label: 'PB - Paraíba' },
  { value: 'PR', label: 'PR - Paraná' },
  { value: 'PE', label: 'PE - Pernambuco' },
  { value: 'PI', label: 'PI - Piauí' },
  { value: 'RJ', label: 'RJ - Rio de Janeiro' },
  { value: 'RN', label: 'RN - Rio Grande do Norte' },
  { value: 'RS', label: 'RS - Rio Grande do Sul' },
  { value: 'RO', label: 'RO - Rondônia' },
  { value: 'RR', label: 'RR - Roraima' },
  { value: 'SC', label: 'SC - Santa Catarina' },
  { value: 'SP', label: 'SP - São Paulo' },
  { value: 'SE', label: 'SE - Sergipe' },
  { value: 'TO', label: 'TO - Tocantins' },
];

const allCitiesOption = { value: 'TODAS', label: 'Todas as cidades' };

const documentTypeOptions = [
  { value: 'TODOS', label: 'Todos' },
  { value: 'CPF', label: 'CPF' },
  { value: 'CNPJ', label: 'CNPJ' },
];

const defaultCrawlerConfig = {
  days: '3',
  value: 'R$ 200.000,00',
  type: 'PROMOVENTE',
  state: 'TODOS',
  city: 'TODAS',
  documentType: 'TODOS',
};

const crawlerExecutionStorageKey = 'xavier:projudi-crawler:last-execution';
const crawlerEntryStatusRetryDelays = [2500, 8000, 15000];

const parseCurrencyValue = (rawValue) => {
  const sanitized = String(rawValue || '').replace(/[^\d,.-]/g, '');
  if (!sanitized) return undefined;

  const hasComma = sanitized.includes(',');
  const hasDot = sanitized.includes('.');
  const normalized = hasComma && hasDot
    ? sanitized.replace(/\./g, '').replace(',', '.')
    : sanitized.replace(',', '.');
  const parsed = Number(normalized);

  return Number.isFinite(parsed) ? parsed : undefined;
};

export const ConfigForm = (props) => {
  const api = useMemo(() => AppAPIService.getInstance(), []);
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(false);

  const [isConfirmCrawlerModalOpen, setIsConfirmCrawlerModalOpen] = useState(false);
  const [crawlerExecution, setCrawlerExecution] = useState(null);
  const [crawlerStatus, setCrawlerStatus] = useState(null);
  const [crawlerStatusError, setCrawlerStatusError] = useState('');
  const [crawlerStatusRefreshing, setCrawlerStatusRefreshing] = useState(false);
  const [, setCrawlerStatusFailures] = useState(0);
  const [crawlerStatusUpdatedAt, setCrawlerStatusUpdatedAt] = useState(null);

  const [days, setDays] = useState('');
  const [daysRole, setDaysRole] = useState('');
  const [daysError, setDaysError] = useState('');
  const handleInputDays = (e) => {
    if (e.length < 1) {
      setDays('');
      setDaysError('Campo obrigatório');
      setDaysRole('notOk');
      return;
    } else {
      setDays(e);
      setDaysError('');
      setDaysRole('ok');
    }
  };

  const [value, setValue] = useState('');
  const [valueRole, setValueRole] = useState('');
  const [valueError, setValueError] = useState('');
  const handleInputValue = (e) => {
    if (!e) {
      setValue('');
      setValueError('Campo obrigatório');
      setValueRole('notOk');
    } else {
      setValue(FormatMoney(e));
      setValueError('');
      setValueRole('ok');
    }
  };

  const typeOptions = [
    { value: 'Promovido', label: 'Promovido' },
    { value: 'Promovente', label: 'Promovente' },
    { value: 'Ambos', label: 'Ambos' },
  ];
  const [type, setType] = useState();
  const [typeRole, setTypeRole] = useState('ok');
  const [typeError, setTypeError] = useState('');
  const handleInputProfile = (e) => {
    if (!e) {
      setTypeError('Campo obrigatório');
      setTypeRole('notOk');
    } else {
      setType(e);
      setTypeError('');
      setTypeRole('ok');
    }
  };

  const [state, setState] = useState(stateOptions[0]);
  const [stateRole, setStateRole] = useState('ok');
  const [stateError, setStateError] = useState('');
  const handleInputState = (e) => {
    if (!e) {
      setStateError('Campo obrigatório');
      setStateRole('notOk');
    } else {
      setState(e);
      setStateError('');
      setStateRole('ok');
      setCity(allCitiesOption);
      setCityOptions([allCitiesOption]);
    }
  };

  const [city, setCity] = useState(allCitiesOption);
  const [cityOptions, setCityOptions] = useState([allCitiesOption]);
  const [cityRole, setCityRole] = useState('ok');
  const [cityError, setCityError] = useState('');
  const handleInputCity = (e) => {
    if (!e) {
      setCityError('Campo obrigatório');
      setCityRole('notOk');
    } else {
      setCity(e);
      setCityError('');
      setCityRole('ok');
    }
  };

  const [documentType, setDocumentType] = useState(documentTypeOptions[0]);
  const [documentTypeRole, setDocumentTypeRole] = useState('ok');
  const [documentTypeError, setDocumentTypeError] = useState('');
  const handleInputDocumentType = (e) => {
    if (!e) {
      setDocumentTypeError('Campo obrigatório');
      setDocumentTypeRole('notOk');
    } else {
      setDocumentType(e);
      setDocumentTypeError('');
      setDocumentTypeRole('ok');
    }
  };

  useEffect(() => {
    const selectedState = state?.value;
    if (!selectedState || selectedState === 'TODOS') {
      setCityOptions([allCitiesOption]);
      setCity(allCitiesOption);
      setCityError('');
      setCityRole('ok');
      return undefined;
    }

    let isMounted = true;
    setCityOptions([allCitiesOption]);
    setCity((currentCity) => currentCity?.value ? currentCity : allCitiesOption);

    fetch(`https://servicodados.ibge.gov.br/api/v1/localidades/estados/${selectedState}/municipios`)
      .then((response) => response.ok ? response.json() : [])
      .then((cities) => {
        if (!isMounted) return;
        const options = [
          allCitiesOption,
          ...(Array.isArray(cities)
            ? cities
              .map((item) => ({
                value: String(item?.nome || '').trim(),
                label: String(item?.nome || '').trim(),
              }))
              .filter((item) => item.value)
            : []),
        ];
        setCityOptions(options);
        setCity((currentCity) => {
          if (!currentCity?.value || currentCity.value === 'TODAS') return allCitiesOption;
          return options.find((option) => option.value === currentCity.value) || allCitiesOption;
        });
      })
      .catch(() => {
        if (!isMounted) return;
        setCityOptions([allCitiesOption]);
        setCity(allCitiesOption);
      });

    return () => {
      isMounted = false;
    };
  }, [state?.value]);

  const formIsValid = useCallback(() => {
    let validForm = true;

    validForm =
      days !== '' &&
      daysRole === 'ok' &&
      value !== '' &&
      valueRole === 'ok' &&
      type !== '' &&
      typeRole === 'ok' &&
      state !== '' &&
      stateRole === 'ok' &&
      city !== '' &&
      cityRole === 'ok' &&
      documentType !== '' &&
      documentTypeRole === 'ok';

    return validForm;
  }, [days, daysRole, value, valueRole, type, typeRole, state, stateRole, city, cityRole, documentType, documentTypeRole]);

  const buildConfigQuery = (includeState = true) => {
    const values = [
      {
        integration: 'PROJUDI',
        key: 'periodInDays',
      },
      {
        integration: 'PROJUDI',
        key: 'minimumValue',
      },
      {
        integration: 'PROJUDI',
        key: 'type',
      },
      {
        integration: 'PROJUDI',
        key: 'documentType',
      },
    ];

    if (includeState) {
      values.push({
        integration: 'PROJUDI',
        key: 'state',
      });
      values.push({
        integration: 'PROJUDI',
        key: 'city',
      });
    }

    return JSON.stringify(values);
  };

  const loadConfig = async (includeState = true) => {
    const response = await api.makeHttpRequest({
      url: `/integration`,
      method: 'GET',
      params: {
        values: buildConfigQuery(includeState),
      },
    });

    return Array.isArray(response?.data) ? response.data : response || [];
  };

  const applyConfig = (config = []) => {
    const days = config.find(
      (integration) => integration.key === 'periodInDays'
    )?.value || defaultCrawlerConfig.days;
    const value = config.find(
      (integration) => integration.key === 'minimumValue'
    )?.value || defaultCrawlerConfig.value;
    const type = config.find((integration) => integration.key === 'type')?.value || defaultCrawlerConfig.type;
    const state = config.find((integration) => integration.key === 'state')?.value || defaultCrawlerConfig.state;
    const city = config.find((integration) => integration.key === 'city')?.value || defaultCrawlerConfig.city;
    const documentType = config.find((integration) => integration.key === 'documentType')?.value || defaultCrawlerConfig.documentType;
    const selectedState = stateOptions.find((option) => option.value === String(state).toUpperCase()) || stateOptions[0];
    const selectedDocumentType = documentTypeOptions.find((option) => option.value === String(documentType).toUpperCase()) || documentTypeOptions[0];

    setDays(days);
    setDaysRole('ok');
    setValue(value);
    setValueRole('ok');
    setType({ value: type, label: type });
    setTypeRole('ok');
    setState(selectedState);
    setStateRole('ok');
    setCity(city && city !== 'TODAS' ? { value: city, label: city } : allCitiesOption);
    setCityRole('ok');
    setDocumentType(selectedDocumentType);
    setDocumentTypeRole('ok');
  };

  const getConfig = async () => {
    try {
      setIsLoading(true);

      let config = [];

      try {
        config = await loadConfig(true);
      } catch (error) {
        config = await loadConfig(false);
      }

      applyConfig(config);

      setIsLoading(false);
    } catch (error) {
      applyConfig();
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getConfig();
  }, []);

  const loadActiveCrawlerStatus = useCallback(async () => {
    if (crawlerExecution?.cycleId) return;

    const storedExecution = readStoredCrawlerExecution();
    const cycleId = storedExecution?.cycleId || buildCrawlerMonitorCycleId();

    try {
      const response = await api.makeHttpRequest({
        url: '/projudi/params/status',
        method: 'GET',
        params: { cycleId },
        timeout: 15000,
      });
      const nextStatus = normalizeCrawlerStatus(response, cycleId);

      if (!shouldShowCrawlerPanel(nextStatus, Boolean(storedExecution))) {
        if (storedExecution && nextStatus?.isFinished) clearStoredCrawlerExecution();
        return;
      }

      setCrawlerExecution({
        cycleId: nextStatus.cycleId || cycleId,
        startedAt:
          storedExecution?.startedAt ||
          nextStatus?.executions?.firstCreatedAt ||
          nextStatus?.operational?.queue?.checkedAt ||
          new Date().toISOString(),
        autoDetected: true,
      });
      setCrawlerStatus(nextStatus);
      setCrawlerStatusError('');
      setCrawlerStatusFailures(0);
      setCrawlerStatusUpdatedAt(new Date().toISOString());
    } catch (error) {
      // A leitura de entrada é silenciosa para não bloquear a tela de parametrização.
    }
  }, [api, crawlerExecution?.cycleId]);

  useEffect(() => {
    loadActiveCrawlerStatus();

    const retryTimers = crawlerEntryStatusRetryDelays.map((delay) => (
      setTimeout(loadActiveCrawlerStatus, delay)
    ));

    return () => {
      retryTimers.forEach(clearTimeout);
    };
  }, [loadActiveCrawlerStatus]);

  const loadCrawlerStatus = useCallback(async () => {
    if (!crawlerExecution?.cycleId) return;

    try {
      setCrawlerStatusRefreshing(true);
      const response = await api.makeHttpRequest({
        url: '/projudi/params/status',
        method: 'GET',
        params: { cycleId: crawlerExecution.cycleId },
        timeout: 45000,
      });
      const nextStatus = normalizeCrawlerStatus(response, crawlerExecution.cycleId);
      setCrawlerStatus((previousStatus) => {
        const previousTotal = Number(previousStatus?.executions?.total || 0);
        const nextTotal = Number(nextStatus?.executions?.total || 0);
        const nextStatusType = String(nextStatus?.status || '').toUpperCase();

        if (nextStatusType === 'NOT_FOUND' && previousTotal > 0 && nextTotal === 0) {
          return {
            ...previousStatus,
            status: 'RUNNING',
            progress: Math.max(resolveCrawlerProgress(previousStatus), 1),
          };
        }

        return nextStatus;
      });
      setCrawlerStatusError('');
      setCrawlerStatusFailures(0);
      setCrawlerStatusUpdatedAt(new Date().toISOString());
    } catch (error) {
      setCrawlerStatusFailures((previousFailures) => {
        const nextFailures = previousFailures + 1;
        const status = error?.response?.status;
        const message = error?.response?.data?.message || error?.message || 'erro desconhecido';
        const detail = status
          ? `Não foi possível atualizar o status do crawler (${nextFailures} tentativa${nextFailures > 1 ? 's' : ''}). API retornou ${status}: ${message}`
          : `Não foi possível atualizar o status do crawler (${nextFailures} tentativa${nextFailures > 1 ? 's' : ''}). ${message}`;

        setCrawlerStatus((previousStatus) => ({
          ...(previousStatus || buildInitialCrawlerStatus({ queuedCount: 1 }, crawlerExecution.cycleId)),
          cycleId: crawlerExecution.cycleId,
          status: 'STATUS_UNAVAILABLE',
          progress: Math.max(resolveCrawlerProgress(previousStatus), 1),
          isFinished: false,
          statusMessage: 'A execução foi solicitada, mas o painel ainda não conseguiu ler o progresso detalhado.',
          technicalMessage: detail,
        }));
        setCrawlerStatusError(detail);
        setCrawlerStatusUpdatedAt(new Date().toISOString());
        return nextFailures;
      });
    } finally {
      setCrawlerStatusRefreshing(false);
    }
  }, [api, crawlerExecution]);

  useEffect(() => {
    if (!crawlerExecution?.cycleId) return undefined;

    loadCrawlerStatus();
    if (crawlerStatus?.isFinished) return undefined;

    const interval = setInterval(() => {
      loadCrawlerStatus();
    }, 5000);

    return () => clearInterval(interval);
  }, [crawlerExecution, crawlerStatus?.isFinished, loadCrawlerStatus]);

  const handleCrawlerStarted = useCallback((execution) => {
    const nextExecution = {
      ...execution,
      startedAt: new Date().toISOString(),
    };
    storeCrawlerExecution(nextExecution);
    setCrawlerExecution(nextExecution);
    setCrawlerStatus(buildInitialCrawlerStatus(execution?.initialStatus, nextExecution.cycleId));
    setCrawlerStatusError(execution?.warning || '');
    setCrawlerStatusFailures(0);
    setCrawlerStatusUpdatedAt(new Date().toISOString());
  }, []);

  const clearCrawlerStatus = useCallback(() => {
    clearStoredCrawlerExecution();
    setCrawlerExecution(null);
    setCrawlerStatus(null);
    setCrawlerStatusError('');
    setCrawlerStatusFailures(0);
    setCrawlerStatusUpdatedAt(null);
  }, []);

  const submitCreation = async (e) => {
    setIsLoading(true);
    e.preventDefault();

    try {
      setIsLoading(true);
      await api.makeHttpRequest({
        url: `/integration`,
        method: 'POST',
        data: {
          values: [
            {
              integration: 'PROJUDI',
              key: 'periodInDays',
              value: String(days),
            },
            {
              integration: 'PROJUDI',
              key: 'minimumValue',
              value: String(value),
            },
            {
              integration: 'PROJUDI',
              key: 'type',
              value: type?.value,
            },
            {
              integration: 'PROJUDI',
              key: 'state',
              value: state?.value || 'TODOS',
            },
            {
              integration: 'PROJUDI',
              key: 'city',
              value: city?.value || 'TODAS',
            },
            {
              integration: 'PROJUDI',
              key: 'documentType',
              value: documentType?.value || 'TODOS',
            },
          ],
        },
      });

      setIsLoading(false);
      Swal.fire({
        icon: 'success',
        title: 'Sucesso!',
        text: 'Configurações criada com sucesso',
      }).then(() => {
        history.push('/admin/parametrizacao');
      });
    } catch (error) {
      console.error('error: ', error);
      setIsLoading(false);
    } finally {
      setIsLoading(false);
    }
  };
  /* end submitCreation */

  /* clean form */
  const onCleanForm = async () => {
    setValue('');
    setValueError('');
    setValueRole('');
    setDays('');
    setDaysError('');
    setDaysRole('');
    setType('');
    setTypeError('');
    setTypeRole('');
    setState(stateOptions[0]);
    setStateError('');
    setStateRole('ok');
    setCity(allCitiesOption);
    setCityError('');
    setCityRole('ok');
    setCityOptions([allCitiesOption]);
    setDocumentType(documentTypeOptions[0]);
    setDocumentTypeError('');
    setDocumentTypeRole('ok');
  };

  /* end clean form */
  return (
    <>
      <Container
        style={{
          display: 'block',
          margin: '0',
          padding: '0',
        }}
        maxWidth="xl"
      >
        <Loading isLoading={isLoading} />
        <Container
          style={{
            width: '100%',
            display: 'block',
            padding: 0,
            margin: '0 !important',
          }}
          maxWidth="xl"
        >
          <form
            className={styles.form}
            autoComplete="off"
            style={{
              padding: '0 !important',
              margin: '0 !important',
            }}
          >
            <div
              className={styles.containerInputs}
              style={{
                padding: '0 !important',
              }}
            >
              <Grid container style={{}}>
                <Grid md={12}>
                  <InputForm
                    type="number"
                    name="days"
                    placeholder="Digite o número de dias"
                    label="Período de busca em dias"
                    value={days}
                    error={daysError}
                    onChange={handleInputDays}
                    role={daysRole}
                    required
                  />
                </Grid>
                <Grid
                  md={12}
                  style={{
                    marginTop: '29px',
                  }}
                >
                  <InputForm
                    type="text"
                    name="value"
                    placeholder="Digite o valor mínimo"
                    label="Valor mínimo"
                    value={value}
                    onChange={handleInputValue}
                    role={valueRole}
                    error={valueError}
                    required
                  />
                </Grid>
                <Grid
                  md={12}
                  style={{
                    marginTop: '29px',
                  }}
                >
                  <InputForm
                    type="text"
                    name="type"
                    placeholder="Selecione o tipo"
                    label="Tipo"
                    isSelect={true}
                    options={typeOptions}
                    value={type}
                    required={true}
                    error={typeError}
                    onChange={handleInputProfile}
                    role={typeRole}
                    isClearable={false}
                  />
                </Grid>
                <Grid
                  md={12}
                  style={{
                    marginTop: '29px',
                  }}
                >
                  <InputForm
                    type="text"
                    name="state"
                    placeholder="Selecione o estado"
                    label="Estado"
                    isSelect={true}
                    options={stateOptions}
                    value={state}
                    required={true}
                    error={stateError}
                    onChange={handleInputState}
                    role={stateRole}
                    isClearable={false}
                    isSearchable={true}
                  />
                </Grid>
                <Grid
                  md={12}
                  style={{
                    marginTop: '29px',
                  }}
                >
                  <InputForm
                    type="text"
                    name="city"
                    placeholder="Selecione a cidade"
                    label="Cidade"
                    isSelect={true}
                    options={cityOptions}
                    value={city}
                    required={true}
                    error={cityError}
                    onChange={handleInputCity}
                    role={cityRole}
                    isClearable={false}
                    isSearchable={true}
                  />
                </Grid>
                <Grid
                  md={12}
                  style={{
                    marginTop: '29px',
                  }}
                >
                  <InputForm
                    type="text"
                    name="documentType"
                    placeholder="Selecione CPF/CNPJ"
                    label="CPF/CNPJ"
                    isSelect={true}
                    options={documentTypeOptions}
                    value={documentType}
                    required={true}
                    error={documentTypeError}
                    onChange={handleInputDocumentType}
                    role={documentTypeRole}
                    isClearable={false}
                  />
                </Grid>
              </Grid>
            </div>
          </form>
        </Container>
        <div className={styles.buttonsContainer}>
          <Button
            variant="primary"
            type="submit"
            color={globalColors.primaryColor2}
            onClick={() => setIsConfirmCrawlerModalOpen(true)}
            title="Salvar"
          >
            <span className="text-light">
              Forçar execução do Crawler <IconCircleRight />
            </span>
          </Button>

          <FormActions
            module={'parametrizacao'}
            formIsValid={formIsValid()}
            onCleanForm={onCleanForm}
            onSubmit={submitCreation}
            hideCancel={true}
            messagem
          />
        </div>
        {crawlerExecution?.cycleId && (
          <CrawlerStatusPanel
            execution={crawlerExecution}
            status={crawlerStatus}
            error={crawlerStatusError}
            isRefreshing={crawlerStatusRefreshing}
            lastUpdatedAt={crawlerStatusUpdatedAt}
            onRefresh={loadCrawlerStatus}
            onClear={clearCrawlerStatus}
          />
        )}
      </Container>
      <ConfirmModal
        isOpen={isConfirmCrawlerModalOpen}
        handleOpen={setIsConfirmCrawlerModalOpen}
        onStarted={handleCrawlerStarted}
        crawlerParams={{
          periodInDays: days,
          minimumValue: parseCurrencyValue(value),
          type: type?.value,
          state: state?.value || 'TODOS',
          city: city?.value || 'TODAS',
          documentType: documentType?.value || 'TODOS',
        }}
      />
    </>
  );
};

const CrawlerStatusPanel = ({ execution, status, error, isRefreshing, lastUpdatedAt, onRefresh, onClear }) => {
  const executions = status?.executions || {};
  const leads = status?.leads || {};
  const operationalQueue = status?.operational?.queue || {};
  const hasOperationalQueue = Boolean(operationalQueue.available);
  const finished = Boolean(status?.isFinished);
  const statusType = String(status?.status || '').toUpperCase();
  const isWaitingForQueue = !finished && statusType === 'NOT_FOUND';
  const isStatusUnavailable = statusType === 'STATUS_UNAVAILABLE';
  const hasClickUpLeads = Number(leads.sentToClickUp || 0) > 0;
  const finalReason = status?.finalReason || 'Nenhum lead foi enviado ao ClickUp nesta execução.';
  const processed = Number(executions.finished || 0) + Number(executions.error || 0);
  const total = Number(executions.total || 0);
  const waitingQueue = Number(operationalQueue.waiting || executions.queued || 0);
  const runningQueue = Number(operationalQueue.inProgress || executions.inProgress || 0);
  const delayedQueue = Number(operationalQueue.delayed || 0);
  const operationalTotal = waitingQueue + runningQueue + delayedQueue;
  const progress = hasOperationalQueue && operationalTotal > 0
    ? Math.max(resolveCrawlerProgress(status), Math.round((runningQueue / operationalTotal) * 100), 1)
    : resolveCrawlerProgress(status);
  const startedText = formatDateTime(execution.startedAt);
  const updatedText = lastUpdatedAt ? formatDateTime(lastUpdatedAt) : 'Aguardando primeira leitura';
  const queueCheckedText = operationalQueue.checkedAt
    ? formatDateTime(operationalQueue.checkedAt)
    : updatedText;
  const accentColor = hasClickUpLeads ? '#16876f' : globalColors.primaryColor2;
  const stageLabel = finished
    ? 'Execução finalizada'
    : hasOperationalQueue && runningQueue > 0
      ? 'Processando buscas da fila'
    : hasOperationalQueue && waitingQueue > 0
      ? 'Aguardando processamento na fila'
    : isStatusUnavailable
      ? 'Aguardando leitura do progresso'
    : isWaitingForQueue
      ? 'Preparando fila de busca'
      : 'Processando combinações';

  return (
    <Box
      sx={{
        marginTop: '24px',
        marginBottom: '24px',
        backgroundColor: '#fbfaf9',
        border: '1px solid #e8e3df',
        borderRadius: '4px',
        padding: '16px',
        boxShadow: 'none !important',
        filter: 'none',
        '&, & *': {
          boxShadow: 'none !important',
          textShadow: 'none !important',
          filter: 'none',
        },
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          gap: '16px',
          paddingBottom: '12px',
          borderBottom: '1px solid #e8e3df',
          marginBottom: '12px',
          boxShadow: 'none !important',
          '@media (max-width: 720px)': {
            flexDirection: 'column',
            alignItems: 'stretch',
          },
        }}
      >
        <Box sx={{ display: 'flex', gap: '14px', alignItems: 'center', boxShadow: 'none !important' }}>
          <Box
            sx={{
              width: '46px',
              height: '46px',
              borderRadius: '4px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              backgroundColor: finished ? '#edf8f3' : '#f4efec',
              border: `1px solid ${finished ? '#bfe8d8' : '#e3d8d3'}`,
              color: accentColor,
              fontWeight: 800,
              fontSize: '15px',
              boxShadow: 'none !important',
            }}
          >
            {finished ? '✓' : `${progress}%`}
          </Box>
          <Box>
            <div style={{ color: '#3f4254', fontSize: '16px', fontWeight: 700, textTransform: 'uppercase' }}>
              {finished ? 'Última execução concluída' : 'Crawler em execução'}
            </div>
            <div style={{ color: '#7e8299', fontSize: '12px', marginTop: '4px' }}>
              {stageLabel} · Iniciado em {startedText}
            </div>
          </Box>
        </Box>

        <Box sx={{ display: 'flex', gap: '10px', alignItems: 'center', justifyContent: 'flex-end' }}>
          <StatusActionButton onClick={onRefresh} disabled={isRefreshing}>
            {isRefreshing ? 'Atualizando...' : 'Atualizar'}
          </StatusActionButton>
          {finished && (
            <StatusActionButton onClick={onClear}>
              Ocultar
            </StatusActionButton>
          )}
        </Box>
      </Box>

      <Box sx={{ marginBottom: '14px', boxShadow: 'none !important' }}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: '8px',
            fontSize: '12px',
          }}
        >
          <span style={{ color: '#3f4254', fontWeight: 700, textTransform: 'uppercase' }}>
            {stageLabel}
          </span>
          <span style={{ color: accentColor, fontWeight: 700 }}>
            {hasOperationalQueue && operationalTotal > 0
              ? `${operationalTotal} na fila`
              : total
                ? `${processed}/${total}`
                : updatedText}
          </span>
        </Box>
        <LinearProgress
          variant="determinate"
          value={progress}
          sx={{
            height: '7px',
            borderRadius: '4px',
            backgroundColor: '#ece7e3',
            boxShadow: 'none !important',
            border: '1px solid #e8e3df',
            '& .MuiLinearProgress-bar': {
              borderRadius: '4px',
              backgroundColor: accentColor,
              boxShadow: 'none !important',
            },
          }}
        />
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            color: '#7e8299',
            fontSize: '11px',
            marginTop: '8px',
            gap: '12px',
            '@media (max-width: 720px)': {
              flexDirection: 'column',
            },
          }}
        >
          <span>Ciclo: {execution.cycleId}</span>
          <span>Última leitura: {queueCheckedText}</span>
        </Box>
      </Box>

      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: 'repeat(4, minmax(0, 1fr))',
          borderTop: '1px solid #e8e3df',
          borderLeft: '1px solid #e8e3df',
          borderRadius: '4px',
          overflow: 'hidden',
          boxShadow: 'none !important',
          backgroundColor: '#ffffff',
          '@media (max-width: 720px)': {
            gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
          },
        }}
      >
        <MetricTile
          label={hasOperationalQueue ? 'Fila aguardando' : 'Buscas na fila'}
          value={hasOperationalQueue ? waitingQueue : executions.total || 0}
        />
        <MetricTile
          label={hasOperationalQueue ? 'Em processamento' : 'Buscas concluídas'}
          value={hasOperationalQueue ? runningQueue : processed}
        />
        {hasOperationalQueue ? (
          <MetricTile label="Atrasadas" value={delayedQueue} />
        ) : (
          <MetricTile label="Leads qualificados" value={leads.total || 0} />
        )}
        <MetricTile label="Enviados ao ClickUp" value={leads.sentToClickUp || 0} highlight={hasClickUpLeads} />
      </Box>

      {hasOperationalQueue && (
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
            gap: '10px',
            marginTop: '12px',
            '@media (max-width: 720px)': {
              gridTemplateColumns: '1fr',
            },
          }}
        >
          <OperationalHint label="Leitura da fila" value={queueCheckedText} />
          <OperationalHint
            label="Liberação automática"
            value={formatVisibilityTimeout(operationalQueue.visibilityTimeoutSeconds)}
          />
          <OperationalHint
            label="Resumo operacional"
            value={`${waitingQueue} aguardando · ${runningQueue} processando`}
          />
        </Box>
      )}

      {isStatusUnavailable && !hasOperationalQueue && (
        <StatusMessage
          tone="warning"
          text={[
            status?.statusMessage || 'A execução foi solicitada, mas ainda não foi possível ler o progresso detalhado.',
            error ? `Última tentativa: ${error}` : '',
          ].filter(Boolean).join(' ')}
        />
      )}
      {isStatusUnavailable && hasOperationalQueue && (
        <StatusMessage
          tone="neutral"
          text="Acompanhando a fila operacional em tempo quase real. Os detalhes de leads qualificados aparecem quando cada busca terminar."
        />
      )}
      {error && finished && !hasClickUpLeads && <StatusMessage tone="warning" text={error} />}
      {finished && hasClickUpLeads && (
        <StatusMessage tone="success" text={`${leads.sentToClickUp} lead(s) enviado(s) ao ClickUp com sucesso.`} />
      )}
      {finished && !hasClickUpLeads && (
        <StatusMessage tone="danger" text={finalReason} />
      )}
    </Box>
  );
};

const MetricTile = ({ label, value, highlight = false }) => (
  <Box
    sx={{
      backgroundColor: highlight ? '#f8fffb' : '#ffffff',
      padding: '14px 16px',
      borderRight: '1px solid #e8e3df',
      borderBottom: '1px solid #e8e3df',
      minHeight: '72px',
      boxShadow: 'none !important',
      filter: 'none',
    }}
  >
    <div style={{ color: '#7e8299', fontSize: '11px', textTransform: 'uppercase', fontWeight: 600 }}>
      {label}
    </div>
    <div style={{ color: highlight ? '#16876f' : '#3f4254', fontSize: '22px', fontWeight: 700, marginTop: '7px' }}>
      {value}
    </div>
  </Box>
);

const OperationalHint = ({ label, value }) => (
  <Box
    sx={{
      backgroundColor: '#ffffff',
      border: '1px solid #e8e3df',
      borderRadius: '4px',
      padding: '10px 12px',
      boxShadow: 'none !important',
    }}
  >
    <div style={{ color: '#7e8299', fontSize: '10px', textTransform: 'uppercase', fontWeight: 700 }}>
      {label}
    </div>
    <div style={{ color: '#3f4254', fontSize: '12px', marginTop: '4px', fontWeight: 600 }}>
      {value || '-'}
    </div>
  </Box>
);

const StatusActionButton = ({ children, disabled, onClick }) => (
  <button
    type="button"
    disabled={disabled}
    onClick={onClick}
    style={{
      minWidth: '112px',
      height: '36px',
      padding: '0 16px',
      borderRadius: '4px',
      border: `1px solid ${disabled ? '#d7d2cd' : globalColors.primaryColor2}`,
      background: disabled ? '#f2f0ed' : '#ffffff',
      color: disabled ? '#9a938c' : globalColors.primaryColor2,
      fontWeight: 700,
      fontSize: '12px',
      textTransform: 'uppercase',
      cursor: disabled ? 'not-allowed' : 'pointer',
      boxShadow: 'none !important',
      filter: 'none',
    }}
  >
    {children}
  </button>
);

const StatusMessage = ({ tone, text }) => {
  const colors = {
    success: { background: '#e8fff3', color: '#0e7f5c', border: '#b8f1d6' },
    warning: { background: '#fff8dd', color: '#8a6d00', border: '#ffe8a3' },
    danger: { background: '#fff5f8', color: '#a61b45', border: '#ffd1df' },
    neutral: { background: '#f8f6f3', color: '#6d6474', border: '#ebe4dd' },
  };
  const palette = colors[tone] || colors.warning;

  return (
    <Box
      sx={{
        backgroundColor: palette.background,
        border: `1px solid ${palette.border}`,
        borderRadius: '4px',
        padding: '12px 14px',
        marginTop: '10px',
      }}
    >
      <div style={{ color: palette.color, fontSize: '13px', margin: 0 }}>
        {text}
      </div>
    </Box>
  );
};

const formatDateTime = (rawValue) => {
  if (!rawValue) return '-';
  const date = new Date(rawValue);
  if (Number.isNaN(date.getTime())) return '-';
  return date.toLocaleString('pt-BR');
};

const formatVisibilityTimeout = (seconds) => {
  const parsed = Number(seconds || 0);
  if (!Number.isFinite(parsed) || parsed <= 0) return '-';
  if (parsed < 60) return `${parsed}s`;
  return `${Math.round(parsed / 60)} min`;
};

const normalizeCrawlerStatus = (response, cycleId) => {
  const payload = response?.data || response || {};
  const executions = payload.executions || {};
  const leads = payload.leads || {};
  const isPortalCycle = /^portal-crawler-\d{10,}$/.test(String(payload.cycleId || cycleId || ''));
  const rawTotal = Number(executions.total || payload.queuedCount || 0);
  const statusType = String(payload.status || '').toUpperCase();
  const shouldKeepAlive = isPortalCycle
    && rawTotal === 0
    && ['NOT_FOUND', 'STATUS_UNAVAILABLE', ''].includes(statusType);
  const total = shouldKeepAlive ? 1 : rawTotal;
  const finished = Number(executions.finished || 0);
  const error = Number(executions.error || 0);
  const processed = finished + error;
  const progress = Number.isFinite(Number(payload.progress))
    ? Number(payload.progress)
    : total > 0
      ? Math.min(100, Math.round((processed / total) * 100))
      : 0;

  return {
    cycleId: payload.cycleId || cycleId,
    status: shouldKeepAlive ? 'RUNNING' : (payload.status || (total > 0 ? 'RUNNING' : 'NOT_FOUND')),
    progress,
    isFinished: Boolean(payload.isFinished || (total > 0 && processed >= total)),
    executions: {
      total,
      queued: shouldKeepAlive ? 1 : Number(executions.queued || payload.queuedCount || 0),
      inProgress: Number(executions.inProgress || 0),
      finished,
      error,
      firstCreatedAt: executions.firstCreatedAt,
      lastUpdatedAt: executions.lastUpdatedAt,
    },
    leads: {
      total: Number(leads.total || 0),
      sentToClickUp: Number(leads.sentToClickUp || 0),
    },
    finalReason: payload.finalReason,
    statusMessage: shouldKeepAlive
      ? 'A execução foi solicitada e a fila está sendo preparada.'
      : payload.message,
    technicalMessage: payload.technicalMessage,
    operational: payload.operational,
  };
};

const buildInitialCrawlerStatus = (response, cycleId) => {
  const payload = response?.data || response || {};
  const isPortalCycle = /^portal-crawler-\d{10,}$/.test(String(payload.cycleId || cycleId || ''));
  const queuedCount = Number(payload.queuedCount || (isPortalCycle ? 1 : 0));

  if (!queuedCount) return null;

  return {
    cycleId: payload.cycleId || cycleId,
    status: 'RUNNING',
    progress: 1,
    isFinished: false,
    executions: {
      total: queuedCount,
      queued: queuedCount,
      finished: 0,
      error: 0,
      firstCreatedAt: new Date().toISOString(),
      lastUpdatedAt: new Date().toISOString(),
    },
    leads: {
      total: 0,
      sentToClickUp: 0,
    },
    finalReason: undefined,
    statusMessage: payload.message || 'A execução foi solicitada e a fila está sendo preparada.',
  };
};

const buildCrawlerMonitorCycleId = () => `portal-crawler-monitor-${Date.now()}`;

const shouldShowCrawlerPanel = (status, hasStoredExecution = false) => {
  if (!status || status.isFinished) return false;

  const queueTotal = getOperationalQueueTotal(status);
  if (queueTotal > 0) return true;

  const executions = status.executions || {};
  const total = Number(executions.total || 0);
  const statusType = String(status.status || '').toUpperCase();

  return hasStoredExecution && total > 0 && ['RUNNING', 'STATUS_UNAVAILABLE', 'NOT_FOUND'].includes(statusType);
};

const getOperationalQueueTotal = (status) => {
  const queue = status?.operational?.queue || {};
  if (!queue.available) return 0;
  return Number(queue.waiting || 0) + Number(queue.inProgress || 0) + Number(queue.delayed || 0);
};

const storeCrawlerExecution = (execution) => {
  try {
    window.localStorage.setItem(
      crawlerExecutionStorageKey,
      JSON.stringify({
        cycleId: execution?.cycleId,
        startedAt: execution?.startedAt || new Date().toISOString(),
      }),
    );
  } catch (error) {
    // localStorage pode estar indisponível em navegação privada; o painel segue via estado local.
  }
};

const readStoredCrawlerExecution = () => {
  try {
    const rawValue = window.localStorage.getItem(crawlerExecutionStorageKey);
    if (!rawValue) return null;

    const parsed = JSON.parse(rawValue);
    if (!parsed?.cycleId) return null;

    const startedAt = new Date(parsed.startedAt || 0);
    const ageInHours = (Date.now() - startedAt.getTime()) / (1000 * 60 * 60);
    if (Number.isNaN(startedAt.getTime()) || ageInHours > 6) {
      clearStoredCrawlerExecution();
      return null;
    }

    return parsed;
  } catch (error) {
    clearStoredCrawlerExecution();
    return null;
  }
};

const clearStoredCrawlerExecution = () => {
  try {
    window.localStorage.removeItem(crawlerExecutionStorageKey);
  } catch (error) {
    // Sem ação: limpeza de storage não deve impactar o uso da tela.
  }
};

const resolveCrawlerProgress = (status) => {
  const rawProgress = Number(status?.progress || 0);
  if (Number.isFinite(rawProgress) && rawProgress > 0) {
    return Math.max(0, Math.min(100, rawProgress));
  }
  const executions = status?.executions || {};
  const total = Number(executions.total || 0);
  const processed = Number(executions.finished || 0) + Number(executions.error || 0);
  if (total > 0) return Math.min(100, Math.round((processed / total) * 100));
  return status ? 2 : 0;
};
